// @flow

import React, { type Node } from 'react';
import { Empty } from '../components';
import { useIncomingPayment, getCountry } from '@tectonics/prs/incoming-payment';
import { type UserInputValidationError, serverErrorMessage } from '@tectonics/prs/validation';
import { type Country } from '@tectonics/prs/country';

type Props = {
  validationError: ?UserInputValidationError,
  getMessage: GetSimpleMessage,
  getFallbackMessage?: GetSimpleMessage,
};

export function SimpleTextErrorMessage({
  validationError,
  getMessage,
  getFallbackMessage = getServerErrorFallbackMessage,
}: Props): Node {
  const incomingPayment = useIncomingPayment();
  const country = getCountry(incomingPayment);

  if (!validationError) {
    return <Empty />;
  }

  const message = getMessage(validationError, country);
  if (!message) {
    return getFallbackMessage(validationError, country) || <Empty />;
  }

  return message;
}

type GetSimpleMessage = (UserInputValidationError, Country) => ?Node;

function getServerErrorFallbackMessage(validationError: UserInputValidationError, country: Country): ?string {
  return serverErrorMessage(validationError.payload);
}
